<template>
    <div>
        <template v-if="payment_preference === true">
          <div v-if="payment_preference_balances === true">
          <h1 class="float-left"> Payment Providers </h1>
          <div v-if="payment_providers != null">
            <table id="PoolAccountBalances" class="table" width="100%">
              <thead>
              <tr>
                <th>Name</th>
                <th>Balance</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{payment_providers.easyPaisa.name}}</td>
                <td>{{payment_providers.easyPaisa.balance}}</td>
              </tr>
              <tr>
                <td>{{payment_providers.finca.name}}</td>
                <td>{{payment_providers.finca.balance}}</td>
              </tr>
              </tbody>
            </table>
          </div>
          </div>
          <h1 class="float-left"> Last set Payment Preferences for all Companies </h1>
          <table id="lastDefaultPaymentPreferences" class="table" width="100%">
            <thead>
            <tr>
              <th>IBFT</th>
              <th>BILL</th>
              <th>TOPUP</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="default_history">
              <td>{{default_history.IBFT}}</td>
              <td>{{default_history.BILL}}</td>
              <td>{{default_history.TOPUP}}</td>
            </tr>
            </tbody>
          </table>
          <div class="page-top mb-1 mb-3 clearfix">
          <router-link to="/editAllCompanyPaymentPreference" class="btn btn-primary active float-left"> Change Payment Preference for all Companies</router-link>
          </div>
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Payment Preference </h1>
                <router-link to="/addPaymentPreference" class="btn btn-primary active float-right"> Add Company</router-link>
              <div class="searching float-right mr-2">
                <input id="customSearch" type="text" class="form-control search" companyName="" />
              </div>
            </div>
            <table id="PaymentPreferenceFeeTable" class="table" width="100%">
                <thead>
                    <tr>
                        <th>Company</th>
                        <th>IBFT</th>
                        <th>BILL</th>
                        <th>TOPUP</th>
                        <th>Status</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="payment_preference === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="payment_preference === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                pageView: null,
              payment_preference: null,
              payment_providers: null,
              default_history: null,
              payment_preference_balances: null
            };
        },
        methods: {
            callDataTable(){
                var that = this;
                var PaymentPreferenceFeeTable = $('#PaymentPreferenceFeeTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    searching: true,
                    ajax: {
                        "url": "api/listPaymentPreference",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'companyName'},
                        {data: 'IBFT'},
                        {data: 'BILL'},
                        {data: 'TOPUP'},
                        {data: 'status'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editPaymentPreference/'+full['company_id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit" ><i class="fas fa-pencil-alt"></i></a>';
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    // "columnDefs": [{
                    //         className: "text-center",
                    //         "targets": [ 6 ]
                    //     }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
              $('#customSearch').on( 'keyup', function (e) {
                if (e.keyCode === 13) {
                  PaymentPreferenceFeeTable.search(this.value).draw();
                }
              });
            },
          balancesTableData(){
            this.beneficiaryLoad = true;
            axios.get('/api/paymentProviderBalancesList')
                .then(res => {
                  if(res.status == 200){
                    if(res.data != null){
                      this.payment_providers = res.data;
                    }
                  }else{
                    console.log('error','Error to load payment providers data');
                  }
                })
                .catch(err => {
                  console.log(err);
                });
          },
          lastSetDefaultPaymentPreferenceTableData(){
            this.beneficiaryLoad = true;
            axios.get('/api/lastSetDefaultPaymentPreference')
                .then(res => {
                  if(res.status == 200){
                    if(res.data != null){
                      this.default_history = res.data;
                      // alert(this.default_history.IBFT);
                    }
                  }else{
                    console.log('error','Error to load last set payment preference for all companies data');
                  }
                })
                .catch(err => {
                  console.log(err);
                });
          }
        },
        mounted() { 
            this.$Progress.start();
			this.can('payment_preference|payment_preference_balances').then(result => {
                this.payment_preference = result.payment_preference;
                this.payment_preference_balances = result.payment_preference_balances;
            }).then(result => {
                if(this.payment_preference == true){
					this.callDataTable();
          this.lastSetDefaultPaymentPreferenceTableData();
          if (this.payment_preference_balances == true){
            this.balancesTableData();
          }
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });

        },
    }
</script>
